import axios        from 'axios';
import Routing        from '../app/router'
require('promise.prototype.finally').shim();

const instance = axios.create();
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

instance.interceptors.response.use(
    res => res,
    error =>  {
        if(error.response.status === 403){
            const url = Routing.generate('session_login', {}, false);
            window.location.assign(url);
        }
        throw error;
    });

export default instance